/** @type {(name: string) => (response: Response) =>string | null} */
export const header = name => response => response.headers.get(name);

export const contentType = header("Content-Type");
